import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenderDetailsComponent } from './_components/tender-details/tender-details.component';
import { TenderDetailsRoutingModule } from './tender-details-routing.module';
import { KeywordsSectionModule } from '../tenders/_components/keywords-section/keywords-section.module';
import { ThankYouPageModule } from '../shared/_components/thankyou-modal/thankyou-modal.module';

import { CredlixAdsListingModule } from '../shared/_components/credlix-ads-listing-page/credlix-ads-listing-page.module';
import { SupplierCentralAdsListingModule } from '../shared/_components/supplier-central-ads-listing-page/supplier-central-ads-listing-page.module';
import { SigninWithOtpModule } from "../auth/_components/signin-with-otp/signin-with-otp.module";
import { PipesModule } from '../tenders/_pipes/amount-pipes.module';

import { SimilarTenderModule } from './../shared/_components/similar-tender/similar-tender.module';
import { CommonSideCardModule } from './_components/common-side-card/common-side-card.module';

import { RestrictByFeatureDirective } from './../auth/_directives/restrict-plan-directive.directive';


import { NotificationComponent } from './../shared/_components/shared-notification/notification.component';
@NgModule({
    declarations: [
        TenderDetailsComponent,
        RestrictByFeatureDirective,
        NotificationComponent
    ],
    imports: [
        CommonModule,
        TenderDetailsRoutingModule,
        PipesModule,
        KeywordsSectionModule,
        CredlixAdsListingModule,
        SupplierCentralAdsListingModule,
        SigninWithOtpModule,
        SimilarTenderModule,
        CommonSideCardModule,
        ThankYouPageModule,
    ]
})
export class TenderDetailsModule { }
